import { useEffect, useLayoutEffect, useState } from "react";

export const useMediaQuery = (query) => {
  const [match, setMatch] = useState(() => window.matchMedia(query).matches);
  useEffect(() => {
    const mq = window.matchMedia(query);
    const handler = () => setMatch(mq.matches);
    handler();
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, [query]);
  return match;
};

export const useIsDesktop = () => useMediaQuery("(min-width: 1024px)");

export const useElementHeight = (ref, fallback) => {
  const [h, setH] = useState(fallback);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    setH(el.offsetHeight);
    const ro = new ResizeObserver(([entry]) => setH(Math.round(entry.contentRect.height)));
    ro.observe(el);
    return () => ro.disconnect();
  }, [ref]);
  return h;
};

export const useElementWidth = (ref, fallback) => {
  const [w, setW] = useState(fallback);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    setW(el.offsetWidth);
    const ro = new ResizeObserver(([entry]) => setW(Math.round(entry.contentRect.width)));
    ro.observe(el);
    return () => ro.disconnect();
  }, [ref]);
  return w;
};
